<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <v-card class='elevation-2 animated fadeIn'>
                    <v-toolbar flat>
                        <v-toolbar-title>Período de Graduación</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex sm4>
                                <NativeSelect v-model="GRADUATION_PERIOD_ID_PK"
                                              id="GRADUATION_PERIOD_ID_PK"
                                              name="GRADUATION_PERIOD_ID_PK"
                                              item-text='GRADUATION_PERIOD_DESCRIPTION'
                                              item-value='GRADUATION_PERIOD_ID_PK'
                                              :items="GRADUATION_PERIODS"
                                              label='Período de Graduación'
                                              hint="En esta sección puede configurar el período de graduación que se estará trabajando.">
                                </NativeSelect>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-on:click="updateGraduationPeriod"><v-icon>save</v-icon> Guardar</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import script from './script'
    export default script
</script>


// WEBPACK FOOTER //
// src/components/graduados/periodoGraduacion/component.vue